/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../../../../shared/Loader';
import { ErrorMessage } from '../../../../shared/ErrorMessage/ErrorMessage';
import { fetchPasswordPolicyDetails } from '../../../../store/passwordPolicies/passwordPolicies';
import {
  selectPasswordPolicyDetails,
  selectPasswordPolicyDetailsLoading,
  selectPasswordPolicyDetailsError
} from '../../../../store/passwordPolicies/passwordPoliciesSelector';
import PasswordPolicyRuleDetail from "../../PasswordPolicyRuleDetail/PasswordPolicyRuleDetail";

interface PasswordPolicyDetailsProps {
  passwordPolicyId: string;
}

const PasswordPolicyDetails = ({ passwordPolicyId }: PasswordPolicyDetailsProps) => {
  const policyDetails = useSelector((state: any) => selectPasswordPolicyDetails(state, passwordPolicyId));
  const policyDetailsLoading = useSelector((state: any) => selectPasswordPolicyDetailsLoading(state, passwordPolicyId));
  const policyDetailsError = useSelector((state: any) => selectPasswordPolicyDetailsError(state, passwordPolicyId));
  const dispatch = useDispatch();

  useEffect(() => {
    fetchPasswordPolicyDetails(dispatch, passwordPolicyId);
  }, [dispatch, passwordPolicyId]);

  if (policyDetailsLoading) {
    return <Loader showLoader isCenter />;
  }

  if (policyDetailsError) {
    return <ErrorMessage message={policyDetailsError} />;
  }

  return (
    <PasswordPolicyRuleDetail policyDetails={policyDetails} />
  );
};

export default PasswordPolicyDetails;
